import api from '@pray/shared/utils/api';

import type { GivingAccountsAdminListResponse, GivingAccountsAdminParams } from './types';

export async function getGivingAccountsAdmin(params: GivingAccountsAdminParams = {}) {
  const url = '/web/studio/giving-accounts';

  const queryParams: Record<string, string | number> = {};

  if (params.status) queryParams.status = params.status;
  if (params.search) queryParams.search = params.search;
  if (params.limit !== undefined) queryParams.limit = params.limit;
  if (params.offset !== undefined) queryParams.offset = params.offset;

  const response = await api.executeGetRequest<GivingAccountsAdminListResponse>(url, queryParams);

  return response;
}
